<template>
  <div>
    <apexchart
      v-if="seriesdata.length > 0"
      type="bar"
      height="500"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div 
      v-else 
      class="d-flex justify-center align-center titleText--text text-capitalize font-weight-bold ml-3" 
      style="height: 300px">
      <span>No data</span>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  setup() {},
  data: () => ({
    seriesdata: [],
    series: [],
    seriesnew: [],
    chartOptions: null,
     Chartdata:[]
  }),
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    inputdata: null,
    isShowchart: null,
  },
  methods: {
    loadchart(vardata) {
      let tempdata = [];
      tempdata = vardata;
      this.seriesdata = tempdata.filter(item => item.productive_universe > 0.0 || item.client_coverage > 0.0);


      this.series = [];
      let newseries_productive_universe = [];
      let newseries_client_coverage = [];
      let chartcategories = [];
      for (let index = 0; index < this.seriesdata.length; index++) {
        newseries_productive_universe.push(this.seriesdata[index].productive_universe);
        newseries_client_coverage.push(this.seriesdata[index].client_coverage);
        chartcategories.push(this.seriesdata[index].column);
        
      }
     this.series = [
        {
          name: "Productive universe",
          data: newseries_productive_universe,
        },
         {
          name: "Client coverage",
          data: newseries_client_coverage,
        }
      ];
      this.chartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            barHeight: '50%',
          },
        },
        grid: {
            yaxis: {
                lines: {
                    show: false,
                }
            },
            xaxis: {
                lines: {
                    show: true,
                }
            }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        colors: ['#f24141', '#9441f2'],
        xaxis: {
          categories: chartcategories,
          labels: {
            style: {
              colors: '#9AA1A9',
              fontWeight: 'bold'
            },
            formatter: (val) => {
              if (val && val.length > 15) {
                return val.slice(0, 15) + '...'
              } else {
                return val
              }
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#9AA1A9"],
              fontWeight: 'bold'
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          fontWeight: 'bold',
          labels: {
            colors: '#9AA1A9',
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val.toLocaleString("en-US");
            },
          },
        },
      };
    },
  },
  mounted(){
    //this.loadchart();inputdata

     //this.seriesdata=this.inputdata;
  }

};
</script>
